import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import get from 'lodash/get';
import map from 'lodash/map';
import { useSelector, useDispatch } from 'react-redux';
import ShopifyIntegration from '../../components/marketPlace/shopify/shopifyIntegrations';
import { salesChannelManagement } from '../../redux/actions/marketPlaceAction';

const OnlineChannel = () => {
  const [loading, setLoading] = useState(false);
  const selectedCompany = useSelector((state) =>
    get(state, 'auth.selectedCompany')
  );
  const dispatch = useDispatch();

  const [onlineChannel, setOnlineChannel] = useState([]);

  const fetchOnlineChannels = () => {
    setLoading(true);
    dispatch(
      salesChannelManagement('list.sales_channels', {
        company_id: get(selectedCompany, 'id'),
        filters: {
          type: 'ONLINE',
        },
      })
    )
      .then((result) => {
        setLoading(false);
        setOnlineChannel(get(result, 'data'));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchOnlineChannels();
  }, []);

  return (
    <Spin spinning={loading}>
      <div className="normal-heading mt-30">Select Sales Channel</div>
      <div className="channels mt-30">
        {map(onlineChannel, (channel) => {
          if (get(channel, 'code') === 'SHOPIFY') {
            return (
              <ShopifyIntegration
                key={get(channel, 'id')}
                shopifyChannel={channel}
                selectedCompany={selectedCompany}
              />
            );
          }
          return <></>;
        })}
      </div>
    </Spin>
  );
};

export default OnlineChannel;
